import axios from "axios";
import { baseURL } from "./endpoints";

//post call
export const postMethodCall = async (endPoint, payLoad, headers = null) => {
    try {
        var config = {
            method: 'post',
            url: `${baseURL}/${endPoint}`,
            headers: {
                ...headers
            },
            data: JSON.stringify(payLoad)
        };
        //api call
        const response = await axios(config);
        return { code: response.status, msg: response.statusText, data: response.data };
    } catch (e) {
        return { code: 500, msg: "Some error occurred. Please try again later.", data: e };
    }
};

//post call
export const postMethodCallWithFileStream = async (endPoint, payLoad, headers = null) => {
    try {
        //create form data object
        const data = new FormData();
        var keys = Object.keys(payLoad);
        for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            const value = payLoad[key];
            //appending file streams
            if (key === "file") {
                for (let i = 0; i < value.length; i++) {
                    data.append(`file[${i}]`, value[i]);
                }
            } else {
                data.append(key, value);
            }
        }
        //build axios config
        var config = {
            method: 'post',
            url: `${baseURL}/${endPoint}`,
            headers: {
                ...headers
            },
            data: data
        };
        //api call
        const response = await axios(config);
        return { code: response.status, msg: response.statusText, data: response.data };
    } catch (e) {
        return { code: 500, msg: "Some error occurred. Please try again later.", data: e };
    }
};

//get call
export const getMethodCall = async (endPoint, payLoad = null, headers = null) => {
    try {
        var config = {
            method: 'get',
            url: `${baseURL}/${endPoint}`,
            headers: {
                ...headers
            },
            data: (payLoad) ? JSON.stringify(payLoad) : null
        };
        //api call
        const response = await axios(config);
        return { code: response.status, msg: response.statusText, data: response.data };
    } catch (e) {
        return { code: 500, msg: "Some error occurred. Please try again later.", data: null };
    }
};